import PropTypes from 'prop-types';

import Breadcrumb from 'shopper/components/Breadcrumb/V1/Breadcrumb';

import BreadcrumbItem from 'components/Breadcrumb/Item';

import { toArticleCategoryLink } from 'lib/links';
import placeholder from 'lib/placeholder';
import { sliceWithEllipsis } from 'lib/string';

import LINKS from 'constants/links';

const ArticleHeading = ({ articleTitle, categoryName, categorySlug }) => (
  <div className="mx-4 lg:mx-0">
    <Breadcrumb>
      <BreadcrumbItem href={LINKS.HOME}>
        {placeholder('breadcrumbs.promobit')}
      </BreadcrumbItem>
      <BreadcrumbItem href={LINKS.BLOG}>
        {placeholder('breadcrumbs.blog')}
      </BreadcrumbItem>
      <BreadcrumbItem href={toArticleCategoryLink(categorySlug)}>
        {categoryName}
      </BreadcrumbItem>
      <BreadcrumbItem>{sliceWithEllipsis(articleTitle, 48)}</BreadcrumbItem>
    </Breadcrumb>
  </div>
);

ArticleHeading.propTypes = {
  articleTitle: PropTypes.string.isRequired,
  categoryName: PropTypes.string.isRequired,
  categorySlug: PropTypes.string.isRequired,
};

export default ArticleHeading;
